/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import get from 'lodash/get';
import { getStructureBySubstanceId } from '@Services/Results';

export default function useStructureData(params, data) {
  const [isReady, setIsReady] = useState(null);
  const [structure, setStructure] = useState(null);

  useEffect(() => {
    const { databaseId } = params;
    const { id, path } = data;

    setIsReady(false);

    if (path) {
      getStructureBySubstanceId(databaseId, id)
        .then((response) => {
          setStructure(get(response, 'molImage.structure'));
          setIsReady(true);
        })
        .catch(Logger.error);
    } else {
      setIsReady(true);
    }
  }, [data]);

  return { isReady, structure };
}
